require('./OKSliderInputMiddleLimit.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const OKSliderInput = require('commonsComponents/OKSliderInput');

// @ helpers
const { parseStyles, buildStyles } = require('utilities/contactCenter/stylesHelper');

class OKSliderInputMiddleLimit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            max: parseFloat(props.maximumLimit),
            min: parseFloat(props.minimumLimit),
            middle: parseFloat(props.middleLimit),
            currentLimit: parseFloat(props.defaultValue),
        }

        this.handleOnSliderTrackSizeChange = this.handleOnSliderTrackSizeChange.bind(this);
    }

    parseSliderTrackGradientAndLeftObject() {
        const {max, min, middle, size} = this.state;
        const WIDTH_OFFSET = 40; //This constant is used to substract the 40px of the total width of the slider follow the definition in modifyCommerceAndATMLimitsStep1.scss - line 57
        const PRECISION_OFFSET = 98; //This constant is to fix the mismatch of the minimum value
        const LEFT_PRECISION_OFFSET = 7; //This constant is to fix the mismatch of the label of middle value and put it under the middle value

        let ccLeftPositionObject = {};
        let sliderTrackGradient = {};
        if (size) {
            const sliderTrackStyles = {
                width: size.parentElement.width,
                valueMiddleLimitGradient: ((middle * (size.parentElement.width - WIDTH_OFFSET)) / (max + (min + PRECISION_OFFSET)))
            }

            const contactCenterLeftPositionValue = ((sliderTrackStyles.valueMiddleLimitGradient * 100) / (sliderTrackStyles.width - WIDTH_OFFSET)) - LEFT_PRECISION_OFFSET;
            ccLeftPositionObject = contactCenterLeftPositionValue ? {left: `calc(${sliderTrackStyles.valueMiddleLimitGradient}px - ${(size.labelElement.width / 2)}px)`} : {display: `none`};

            sliderTrackGradient = buildStyles({
                styleType: 'background',
                valueStyle: `linear-gradient(90deg, #002B45 ${sliderTrackStyles.valueMiddleLimitGradient}px, #FF0049 0%)`
            });
        }

        return ({
            ccLeftPositionObject,
            sliderTrackGradient
        });
    }

    assignGradientToElement(sliderTrackGradient){
        const sliderTrack = document.getElementsByClassName('rc-slider-track')[0];
        if (sliderTrack) {
            const styles = parseStyles(sliderTrack.getAttribute('style'));
            sliderTrack.setAttribute("style", `${styles.left} ${styles.width} ${sliderTrackGradient}`);
        }
    }

    handleOnSliderTrackSizeChange(size) {
        this.setState({ size: size });
    }

    buildMiddleLabelElement(stylesObject) {
        if (__CONTACT_CENTER__) {
            const { middleLabel } = this.props;
            return (
                <div style={stylesObject} className="ok-slider-input__second-limit-label">
                    {middleLabel}
                </div>
            );
        }
        return null;
    }

    render() {
        const {minLabel, maxLabel, marks, defaultValue, onChange, currencySign} =  this.props;
        const {ccLeftPositionObject, sliderTrackGradient} = this.parseSliderTrackGradientAndLeftObject();

        this.assignGradientToElement(sliderTrackGradient);
        const middleLabelElement = this.buildMiddleLabelElement(ccLeftPositionObject);

        return (
            <OKSliderInput
                minLabel={minLabel}
                maxLabel={maxLabel}
                marks={marks}
                defaultValue={defaultValue}
                onChange={onChange}
                onSliderTrackSizeChange={this.handleOnSliderTrackSizeChange}
                additionalLabelElement={middleLabelElement}
                unit={currencySign}
            />
        );
    }
}

OKSliderInputMiddleLimit.propTypes = {
    minimumLimit: PropTypes.number,
    middleLimit: PropTypes.number,
    maximumLimit: PropTypes.number,
    minLabel: PropTypes.string,
    maxLabel: PropTypes.string,
    middleLabel: PropTypes.string,
    defaultValue: PropTypes.number,
    onChange: PropTypes.func,
    marks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    currencySign: PropTypes.string
};

OKSliderInputMiddleLimit.defaultProps = {
    defaultValue: 0,
    minimumLimit: 0,
    maximumLimit: 100,
    minLabel: '',
    maxLabel: '',
    middleLabel: '',
    onChange: () => {}
}

module.exports = OKSliderInputMiddleLimit;